import { EntityStatus } from '../../../Entity'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TableStatusCell({ children, statuses, unread, value, ...cellProps }) {
  return Number.isFinite(value) ? (
    <TableCellBase {...cellProps}>
      <EntityStatus id={value} statuses={statuses} />
      {children}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableStatusCell
